module.exports = __webpack_public_path__ + "static/media/btn-edit-profile.3edd95c7.svg";